import "core-js/modules/es.string.search";
import { makeEntityScaffold } from '@classpass/saga-tools';
import { isEmpty } from 'helpers/verify';
import { SearchLayout } from 'features/Search/models/SearchLayout';
export var searchSchedules = makeEntityScaffold('SAGA.API.SEARCH_SCHEDULES', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return options.cursor ? client.search.getSchedulesByCursor(options) : client.search.schedules(options);
}, {
  defaultKey: function defaultKey(client, options) {
    return options.page ? "page_".concat(options.page) : 'page_1';
  }
});
export var keywordAutocomplete = makeEntityScaffold('SAGA.API.KEYWORD_AUTOCOMPLETE', function (client, query, location) {
  return client.search.autocomplete({
    q: query,
    location: location
  }).then(function (data) {
    return data.data.results;
  });
}, {
  defaultKey: 1
});
export var locationAutocomplete = makeEntityScaffold('SAGA.API.LOCATION_AUTOCOMPLETE', function (client, query) {
  return client.search.location.autocomplete({
    query: query
  });
}, {
  defaultKey: 1
});
export var searchLayoutByName = makeEntityScaffold('SAGA.API.SEARCH_LAYOUT', function (client, layoutName) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return client.search.getLayout(layoutName, payload).then(function (_ref) {
    var modules = _ref.data.modules;
    return new SearchLayout(modules, {
      layoutName: layoutName,
      distanceUnit: config.distanceUnit
    });
  });
}, {
  defaultKey: 1
});
export var searchLocationAutocomplete = makeEntityScaffold('SAGA.API.SEARCH_LOCATION_AUTOCOMPLETE', function (client) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      query = _ref2.query,
      near = _ref2.near,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'geocode' : _ref2$type;

  return client.search.location.autocomplete({
    autocomplete_type: type,
    near: isEmpty(near) ? null : {
      lat: near.lat,
      lon: near.lon
    },
    query: query
  }).then(function (data) {
    return data.data;
  });
});
export var searchLocationDetails = makeEntityScaffold('SAGA.API.SEARCH_LOCATION_DETAILS', function (client, placeId) {
  return client.search.location.details(placeId).then(function (data) {
    return data.data;
  });
}, {
  defaultKey: 1
});